import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { generatePictureSourceDataByProxyImage } from 'client/utils/generatePictureSourceData';
import LazyLoadImg from 'client/components/LazyLoadImg';
import { system300 } from 'Mui/styles/color';

export default function ResponsivePicture({
    src = '',
    alt,
    enableLazyLoad = false,
    /* 若沒有 disableMedia，要手動 handle image onLoad 或是 set enableLazyLoad 為 true */
    disableMedia,
    haveBlankBlock = false,
    skeletonHeight = 200,
    onLoad = () => {},
    ...restProps
}) {
    const sourceDataList = useMemo(() => generatePictureSourceDataByProxyImage(src), [src]);

    const imageComp =
        !src && haveBlankBlock ? (
            <Skeleton
                variant="rect"
                animation={false}
                width="100%"
                height={skeletonHeight}
                style={{ color: system300.color, backgroundColor: system300.color }}
            />
        ) : (
            <LazyLoadImg
                enableLazyLoad={enableLazyLoad}
                src={src}
                alt={alt}
                onLoad={onLoad}
                {...restProps}
            />
        );

    return !disableMedia && sourceDataList.length > 0 ? (
        <picture>
            {sourceDataList.map((props, index) => (
                <source key={`${index}-${props.srcSet}`} {...props} />
            ))}
            {imageComp}
        </picture>
    ) : (
        imageComp
    );
}

ResponsivePicture.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    disableMedia: PropTypes.bool,
    enableLazyLoad: PropTypes.bool,
    haveBlankBlock: PropTypes.bool,
    skeletonHeight: PropTypes.number,
    onLoad: PropTypes.func
};
